<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

let globalId = 0;
export default defineComponent({
  name: 'OIconDownload',
  svgType: 'fill',
  setup() {
    const classNames = ['o-svg-icon', 'o-icon-download', 'type-fill'];
    const isClient = ref(false);
    onMounted(() => {
      isClient.value = true;
    });
    return {
      isClient,
      classNames,
      globalId: globalId++,
    };
  },
});
</script>
<template>
  <svg viewBox="0 0 24 24" :class="classNames">
    <template v-if="isClient">
      <path fill-opacity=".8" fill-rule="evenodd" d="M11.998 3.295a.7.7 0 0 1 .694.605l.006.095v11.539l4.525-4.576a.7.7 0 0 1 1.069.897l-.073.087-5.72 5.784a.7.7 0 0 1-1.194-.397l-.007-.095V3.995a.7.7 0 0 1 .7-.7m-5.313 7.588a.7.7 0 0 0-.906 1.06l2.957 2.973.087.074a.7.7 0 0 0 .905-1.062l-2.956-2.972zm12.32 8.476a.7.7 0 0 1 .096 1.394l-.095.006H5.012a.7.7 0 0 1-.095-1.393l.095-.007z"/>
    </template>
  </svg>
</template>